import { useLinesVodDetailGenreStore } from "@/stores/LinesVodDetailGenre";
import { type RouteLocationNormalized } from 'vue-router';
import { useMostPopularVod } from "@/stores/MostPopularVod";
import { linkItems } from "@/components/Header/types";

const {
	clearIndexMostPopular,
	clearMostPopularVodDetailGenre
} = useMostPopularVod();

const {
	fetchNewShowsGenres,
	fetchNewMoviesGenres,
	setCurrentGenre,
	fetchMostPopularDetailGenre,
	clearAllLinesVodDetailGenreStore
} = useLinesVodDetailGenreStore();



export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	if (import.meta.client) {
		try {
			if (to.params.id){
				// If we move from 'onDemand', we clear store
				if (linkItems.onDemand.routerPath) {
					clearIndexMostPopular();
					clearMostPopularVodDetailGenre();
					clearAllLinesVodDetailGenreStore();
				}

				setCurrentGenre(Number(to.params.id)).then((genre) => {
					if (!genre) {
						throw new Error('middleware "fetchVodDetailGenre" genre is null');
					}
					fetchMostPopularDetailGenre(genre);

					fetchNewShowsGenres(genre);

					fetchNewMoviesGenres(genre);
				});
			} else {
				throw new Error('middleware "fetchVodDetailGenre" abortNavigation');
			}
		} catch (error) {
			console.error(error);
			abortNavigation();
		}
	}
});